module.exports = __webpack_public_path__ + "static/img/3s-info-b2.813f3d4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/web/3s-info-b2.jpg
// module id = U+YB
// module chunks = 0